import { useSearchParams } from "react-router-dom";

import { QueryParamConstants, useHaNBuildingResolution } from "@lib/logic";

import { haNSession } from "../state/session/haNSession";

const BUILDING_PARAM = QueryParamConstants.hereAndNow.rooms.buildingId;

/** The shared building resolution, plus the `buildingId` deep link from the URL. */
export const useHaNBuilding = (bucket: number) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const linkedBuildingId = searchParams.get(BUILDING_PARAM);

  // The link wins for as long as it's in the URL, so a link opened before the buildings have loaded still applies
  const building = useHaNBuildingResolution({ session: haNSession, bucket, linkedBuildingId });

  // Choosing a building removes the link, so the choice takes over
  const selectBuilding = (buildingId: string) => {
    building.selectBuilding(buildingId);

    if (!linkedBuildingId) return;

    setSearchParams(
      params => {
        const nextParams = new URLSearchParams(params);
        nextParams.delete(BUILDING_PARAM);
        return nextParams;
      },
      { replace: true },
    );
  };

  return { ...building, selectBuilding };
};

/** The query string for links between H&N tabs. It carries only the building deep link, so a tab switch keeps it. */
export const useHaNTabLinkSearch = () => {
  const [searchParams] = useSearchParams();
  const linkedBuildingId = searchParams.get(BUILDING_PARAM);

  if (!linkedBuildingId) return "";

  return `?${new URLSearchParams({ [BUILDING_PARAM]: linkedBuildingId }).toString()}`;
};
